import { createContext, useContext } from "react";
import { IOfferingGroupsContext } from "./types";

export const OfferingGroupsContext = createContext<IOfferingGroupsContext | null>(null);

export const useOfferingGroupsContext = () => {
  const context = useContext(OfferingGroupsContext);
  if (context === null) {
    throw new Error("useContext must be inside a Provider with a value");
  }
  return context;
};
